import API from './'

const pipeline = {

	/**
	 * Get a list of pipelines.
	 */
	list(params={}, config={})
	{
		let url = API.getUrl(`pipelines`)

		return API.client().get(url, { params, ...config })
	},

	/**
	 * Get one pipeline details.
	 */
	one(id, params={}, config={})
	{
		let url = API.getUrl(`pipeline/${id}`)

		return API.client().get(url, { params, ...config })
	},

	user(params={})
	{
		let url = API.getUrl('user/pipelines')

		return API.client().get(url, { params })
	}

}

export default pipeline